// extracted by mini-css-extract-plugin
export default {"successes":"SuccessMessage_successes__0qzoo","fade-in":"SuccessMessage_fade-in__I7apZ"};